export default {
  en: {
    empty: "Nothing here yet",
    loading: "Loading…",
    error: { title: "Something went wrong", retry: "Retry", load: "Could not load data" },
    pii: { masked: "Hidden personal data (requires the pii-reader role)" },
    crud: { add: "Add", edit: "Edit", delete: "Delete", cancel: "Cancel", save: "Save", create: "Create" },
    serverError: { rejected: "The service rejected the change", conflict: "Conflict: the change could not be applied", forbidden: "You are not allowed to make this change" },
    sla: { remaining: "{{time}} left", overdue: "Overdue by {{time}}", due: "Due {{at}}", none: "No deadline", underMinute: "less than a minute" },
    actions: { save: "Save", cancel: "Cancel", close: "Close", confirm: "Confirm", refresh: "Refresh", search: "Search", reset: "Reset", download: "Download" },
    items_zero: "No items",
    items_one: "One item",
    items_two: "Two items",
    items_few: "{{count}} items",
    items_many: "{{count}} items",
    items_other: "{{count}} items",
    status: {
      running: "Running", awaiting_approval: "Awaiting approval", finished: "Finished", completed: "Completed", error: "Failed", failed: "Failed",
      cancelled: "Cancelled", open: "Open", claimed: "Claimed", pending: "Pending", approved: "Approved", edited: "Approved with edits",
      rejected: "Rejected", expired: "Expired", resolved: "Resolved", closed: "Closed", ok: "Succeeded", production: "Live",
      staging: "Final check", draft: "Draft", suspended: "Suspended", retired: "Retired", not_evaluated: "Not evaluated", firing: "Firing",
      acknowledged: "Acknowledged", healthy: "Healthy", progressing: "Progressing", paused: "Paused", degraded: "Degraded",
      aborted: "Aborted", passing: "Passing", failing: "Failing", mitigated: "Mitigated", engaged: "Stopped", disengaged: "Off",
      allowed: "Allowed", excepted: "Exception", denied: "Denied", unknown: "Unknown", critical: "Critical", warning: "Warning",
      info: "Info", ready: "Ready", processing: "Processing", idle: "Idle", done: "Done", escalated: "Escalated",
      scale_up: "Scale up", scale_down: "Scale down", hold: "Hold",
    },
  },
  ar: {
    empty: "لا يوجد شيء هنا بعد",
    loading: "جارٍ التحميل…",
    error: { title: "حدث خطأ ما", retry: "إعادة المحاولة", load: "تعذر تحميل البيانات" },
    pii: { masked: "بيانات شخصية مخفية (تتطلب دور قارئ البيانات الشخصية)" },
    crud: { add: "إضافة", edit: "تعديل", delete: "حذف", cancel: "إلغاء", save: "حفظ", create: "إنشاء" },
    serverError: { rejected: "رفضت الخدمة التغيير", conflict: "تعارض: تعذّر تطبيق التغيير", forbidden: "غير مسموح لك بإجراء هذا التغيير" },
    sla: { remaining: "متبقٍ {{time}}", overdue: "متأخر بمقدار {{time}}", due: "الموعد {{at}}", none: "بلا موعد نهائي", underMinute: "أقل من دقيقة" },
    actions: { save: "حفظ", cancel: "إلغاء", close: "إغلاق", confirm: "تأكيد", refresh: "تحديث", search: "بحث", reset: "إعادة تعيين", download: "تنزيل" },
    items_zero: "لا توجد عناصر",
    items_one: "عنصر واحد",
    items_two: "عنصران",
    items_few: "{{count}} عناصر",
    items_many: "{{count}} عنصرًا",
    items_other: "{{count}} عنصر",
    status: {
      running: "قيد التشغيل", awaiting_approval: "بانتظار الاعتماد", finished: "مكتمل", completed: "مكتمل", error: "فشل", failed: "فشل",
      cancelled: "ملغى", open: "مفتوح", claimed: "مُسند", pending: "معلّق", approved: "معتمد", edited: "معتمد مع تعديل",
      rejected: "مرفوض", expired: "منتهي", resolved: "محلول", closed: "مغلق", ok: "نجح", production: "إنتاج",
      staging: "تجريبي", draft: "مسودة", suspended: "موقوف", retired: "متقاعد", not_evaluated: "غير مُقيَّم", firing: "نشط",
      acknowledged: "تم الإقرار", healthy: "سليم", progressing: "قيد التقدم", paused: "متوقف مؤقتًا", degraded: "متدهور",
      aborted: "مُجهض", passing: "ناجح", failing: "فاشل", mitigated: "تم التخفيف", engaged: "مُفعّل", disengaged: "مُعطّل",
      allowed: "مسموح", excepted: "استثناء", denied: "مرفوض", unknown: "غير معروف", critical: "حرج", warning: "تحذير",
      info: "معلومة", ready: "جاهز", processing: "قيد المعالجة", idle: "خامل", done: "منجز", escalated: "مُصعَّد",
      scale_up: "توسيع", scale_down: "تقليص", hold: "إبقاء",
    },
  },
};
